<script setup>
import {computed, onBeforeMount, ref, onMounted, watch} from "vue";
import {useStore} from 'vuex'

const store = useStore()
import {state, wsClient} from "@/socket";
import {ProjectApi} from "@/api/projects";
import UserBlock from "@/components/UserBlock.vue";

const projectId = computed(() => store.getters.currentProjectId)
if (projectId.value) {
  getProject(projectId.value)
}
const project = ref({})
watch(projectId, async (value) => {
  if (value) getProject(value)
})

function getProject(id) {
  ProjectApi.object(id).then(response => {
    project.value = response
    store.commit("set_project", response)
  })
}

const ws_state = computed(() => state.project);

watch(ws_state, value => {
  if (value) store.commit("set_project", value)
})

const pages = [

  {name: "Карта барьеров", ico: "briefcase", url: "/", check_user: false, check_company_type: true},
  {name: "Обзор", ico: "house", url: "/dashboard", check_user: false},
  {name: "Аналитика", ico: "bar-chart", url: "/analytics", check_user: false},
  {name: "Отзывы", ico: "chat-left-text", url: "/reviews", check_user: false},
  {name: "Статистика", ico: "clipboard-data", url: "/statistics", check_user: false},
  {name: "Отчёты", ico: "filetype-xls", url: "/reports", check_user: false},
  {name: "Алерты", ico: "alarm", url: "/alerts", check_user: false},
  {name: "История", ico: "clock-history", url: "/history", check_user: false},
  // {name: "Парсер", ico: "arrow-clockwise", url: "/parser", check_user: true, rule: 'history_parser'},
  {name: "Настройки", ico: "gear", url: "/settings", check_user: false},
]

onMounted(() => {
  wsClient.connectWs('user_events')
})

onBeforeMount(() => {
  document.querySelectorAll(".menu .link-dark.rounded").forEach(item => {
    item.addEventListener('click', () => {
      document.getElementById('sidebarMenu').classList.remove("show");
    })
  })
})

function getShortName(project_name) {
  if (project_name) return project_name.split(' ').map(x => x[0]).join('').slice(0, 2).toUpperCase()
  return "-"
}

</script>
<template>
  <nav :class="`sidebar ${$store.getters.sidebar_state?'':'collapse'}`">

    <div class="hide-sidebar" @click="$store.dispatch('toggle_sidebar')">
      <i :class="`bi bi-chevron-double-${$store.getters.sidebar_state?'left':'right'}`"></i>

    </div>


    <div class="menu">
      <router-link class="navbar-brand col-auto" active-class="" to="/"></router-link>

      <div class="area">
        <router-link active-class="active" :class="'projects'+(!$store.getters.currentProject?.active?' inactive':'')"
                     to="/project"
                     title="Проект">
          <span class="logo" :style="{background: project.color}">{{ getShortName(project.name) }}</span>
          <span class="name">{{ project.name ? project.name : "Выберите проект" }}</span>
          <i class="bi bi-chevron-down"></i>
          <span v-if="$store.getters.currentProject&&!$store.getters.currentProject?.active"
                class="status">Не активен</span>

        </router-link>
        <ul class="list-unstyled menu">
          <template v-for="page in pages">
            <template
                v-if="(page.check_company_type && $store.getters.currentProject.company_type) || !page.check_company_type">
              <template
                  v-if="(page.check_user && ($store.getters.currentProject.user_id === $store.getters.user.id)) || !page.check_user">
                <template
                    v-if="page.rule && $store.getters.tariff[page.rule]||!page.rule">
                  <li class="mb-1">

                    <router-link active-class="active" class="rounded" :to="page.url" :title="page.name">
                      <i :class="'bi bi-'+page.ico"></i>
                      <span>{{ page.name }}</span>
                    </router-link>

                  </li>
                </template>
              </template>
            </template>
          </template>
        </ul>
      </div>

    </div>

    <UserBlock></UserBlock>


  </nav>
</template>


<style>
.sidebar {
  display: flex;
  flex-direction: column;
  background: var(--deep-blue);
  height: 100vh;
  width: 270px;
  position: sticky;
  top: 0;
  color: #fff;
  padding-left: 25px;
  overflow-y: scroll;
  scrollbar-width: none; /* Для Firefox */
  -ms-overflow-style: none; /* Для Internet Explorer и */
  /* Для Chrome, Safari, Opera */
  z-index: 1000;

  &::-webkit-scrollbar {
    display: none;
    width: 0;
    height: 0;
  }

  .menu a {
    display: flex;
    gap: 10px;

  }

  &.collapse {
    width: 90px;

    .menu a {
      span:not(.logo) {
        display: none;
      }

      .bi-chevron-down {
        display: none;
      }

      i:not(.bi-chevron-down) {
        font-size: 25px;
      }
    }

    .status {
      display: none;
    }

    .navbar-brand {
      background: url("../../src/assets/images/orion_small.svg") no-repeat center center;
      background-size: contain;
      width: 57px;
    }

  }

  .menu {
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin-top: 20px;

    a {
      color: #fff;

    }

    .list-unstyled {
      gap: 10px;
      margin-bottom: 0;

      a {

        height: 35px;
        align-items: center;
        padding: 5px;
        max-width: 100%;

        &.active {
          background: var(--primary);
          text-decoration: none;
        }
      }
    }
  }

  .projects {
    background: var(--dark-grey);
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 5px;
    width: 100%;
    padding: 5px;
    gap: 10px;
    position: relative;

    &.inactive {
      .status {
        position: absolute;
        top: -8px;
        font-size: 10px;
        background: red;
        border-radius: 5px;
        right: 6px;
        padding: 0 5px;
        color: #fff;
      }
    }

    &:hover {
      text-decoration: none;
    }

    .logo {
      border-radius: 5px;
      background-color: var(--primary);
      font-weight: bold;
      font-size: 13px;
      height: 30px;
      width: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 2px;

    }
  }

  .hide-sidebar {
    width: 20px;
    height: 100vh;
    position: absolute;
    top: 0;
    left: 0;
    border-right: 1px solid var(--dark-grey);
    cursor: pointer;
    color: #fff;
    text-align: center;
    align-items: center;
    display: flex;

    &:hover {
      opacity: 0.8;
    }
  }

  .navbar-brand {
    background: url("../../src/assets/images/forpost.svg") no-repeat center center;
    background-size: contain;
    width: 100%;
    height: 45px;
    display: block;
  }

}

.fast-parse {
  margin-right: 10px;
  white-space: nowrap;
}

@media (width < 768px) {
  .sidebar {
    width: 100%;
    height: 60px;
    bottom: 0;
    position: absolute;
    top: auto;
    padding: 0;

    .projects {
      width: 40px;
    }

    .fast-parse {
      order: 3;
      height: 30px;
      width: 30px;
      font-size: 15px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .area {
      flex-wrap: nowrap;
      display: flex;
      padding: 0;
      border: none;
    }

    .menu {
      flex-direction: row;
      margin: 5px;
      align-items: center;
      justify-content: space-between;
      gap: 5px;

      a {
        span:not(.logo) {
          display: none;
        }

        .bi-chevron-down {
          display: none;
        }

        i:not(.bi-chevron-down) {
          font-size: 30px;
        }
      }
    }

    .status {
      display: none;
    }

    .navbar-brand {
      background: url("../../src/assets/images/orion_small.svg") no-repeat center center;
      background-size: contain;
      width: 30px;
    }

    .hide-sidebar {
      display: none;
    }
  }
}

</style>
